module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "width": _vm.isMobileSize ? '90%' : '40%'
    },
    model: {
      value: (_vm.mostrarModal),
      callback: function($$v) {
        _vm.mostrarModal = $$v
      },
      expression: "mostrarModal"
    }
  }, [_c('v-card', {
    staticClass: "popup-modal"
  }, [_c('v-container', [_c('h3', {
    staticClass: "pb-3",
    class: {
      'display-0': _vm.isMobileSize, 'display-1': !_vm.isMobileSize
    }
  }, [_vm._v("Competências\n                    Pessoais e Profissionais (CPP)")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    class: {
      'body-1': _vm.isMobileSize, 'subheading': !_vm.isMobileSize
    }
  }, [_vm._v("\n                        A URCAMP dá início neste 1º semestre de 2019, ao novo modelo de ensino chamado GRADUAÇÃO I.\n                        É um importante passo para a inovação no ensino superior, implantando o ensino por\n                        competências, onde o aluno sai com uma experiência prática muito mais aprofundada, com\n                        experiências que vão além da sala de aula.\n                        Nesta modalidade todas as noites têm aulas presenciais, sendo que nas noites de sexta-feira\n                        será ministrada a CPP (Competência Pessoal e Profissional), as CPP's são temas inerentes ao\n                        ensino superior, que serão oferecidos para todos os cursos.\n                    ")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "cpp-lista",
    model: {
      value: (_vm.cppSelecionado),
      callback: function($$v) {
        _vm.cppSelecionado = $$v
      },
      expression: "cppSelecionado"
    }
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('v-radio', {
      key: index,
      attrs: {
        "label": ((item.nome) + " / Vagas: " + (item.vagas)),
        "color": "primary",
        "value": item.nome
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "success",
      "block": "",
      "large": "",
      "disabled": !_vm.cppSelecionado
    },
    on: {
      "click": _vm.salvarCpp
    }
  }, [_vm._v("Confirmar Selecão\n                    ")])], 1)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModal = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6385c981!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/popup/GraduacaoICppPopup.vue
// module id = 554
// module chunks = 2